import { render } from "./ServiceStationTxlList.vue?vue&type=template&id=eddc096e&scoped=true&ts=true"
import script from "./serviceStationTxlListHelper.ts?vue&type=script&lang=ts"
export * from "./serviceStationTxlListHelper.ts?vue&type=script&lang=ts"

import "./ServiceStationTxlList.vue?vue&type=style&index=0&id=eddc096e&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eddc096e"]])

export default __exports__